export default __webpack_public_path__ + "static/media/WhatsApp Image 2021-04-07 at 11.31.31 PM.ddd911f5.jpeg";